import { ExperienceType } from '@shared/models/draft';

import { HydrationResult } from './hydration.models';
import type { CooDraftDetails, InheritanceDraft, MinorDraft } from './ku4-draft.models';
import { hydrateInheritance } from './strategies/inheritance.hydrator';
import { hydrateMinor } from './strategies/minor.hydrator';

export function hydrate(draft: CooDraftDetails): HydrationResult {
  if (!draft || !Object.keys(draft).length) {
    return {};
  }

  // Not an exhaustive switch on purpose: drafts carry experienceType values outside the enum
  // (notably 'TRUST'), so anything not explicitly minor must fall through to inheritance.
  const experienceType = (draft as MinorDraft).experienceType;

  if (experienceType === ExperienceType.UGMA_UTMA) {
    return hydrateMinor(draft as MinorDraft);
  }

  return hydrateInheritance(draft as InheritanceDraft);
}
